import { z } from 'zod'
import {
  requiredString,
  optionalString,
  positiveCurrencyPence,
  optionalCurrencyPence,
  optionalIntegerMin,
  optionalBoolean,
  optionalFile
} from './common'

export const packageSchema = z.object({
  name: requiredString('Name'),
  description: optionalString,
  base_price_pence: positiveCurrencyPence('Base price'),
  min_guests: optionalIntegerMin(1, 'Minimum guests'),
  max_guests: optionalIntegerMin(1, 'Maximum guests'),
  duration_minutes: optionalIntegerMin(1, 'Duration'),
  deposit_amount_pence: optionalCurrencyPence('Deposit amount'),
  active: optionalBoolean,
  image: optionalFile,
  menu_document: optionalFile,
  event_type_ids: z.array(z.string()).optional()
}).refine(
  (data) => {
    if (data.min_guests === undefined || data.max_guests === undefined) return true
    return data.max_guests >= data.min_guests
  },
  {
    message: 'Maximum guests must be greater than or equal to minimum guests',
    path: ['max_guests']
  }
)
